import ModalWrap from '../modal-wrap';

type UnsavedChangesModalProps = {
  isOpen: boolean;
  onStay: () => void;
  onLeave: () => void;
};

export const UnsavedChangesModal = ({ isOpen, onStay, onLeave }: UnsavedChangesModalProps) => (
  <ModalWrap isShow={isOpen}>
    <div className="flex w-full max-w-[420px] flex-col gap-5 rounded-2xl bg-white p-6 shadow-shadowPopup">
      <div>
        <h3 className="text-lg font-semibold text-gray-800">Несохранённые изменения</h3>
        <p className="mt-2 text-sm text-gray-600">
          В форме есть несохранённые изменения. Если вы продолжите, они будут потеряны.
        </p>
      </div>

      <div className="flex gap-3">
        <button
          type="button"
          onClick={onStay}
          className="w-full rounded-lg border border-gray-300 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Остаться
        </button>
        <button
          type="button"
          onClick={onLeave}
          className="w-full rounded-lg bg-red-600 py-2.5 text-sm font-medium text-white hover:bg-red-700"
        >
          Не сохранять
        </button>
      </div>
    </div>
  </ModalWrap>
);
